import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DisplayConditionTypeGroup, DisplayConditionTypeValue } from '../../../../shared/domain/display.condition.type';

@Component({
  selector: 'cc-item-main-select',
  templateUrl: './item-main-select.component.html',
  styleUrls: ['./item-main-select.component.scss']
})
export class ItemMainSelectComponent implements OnInit {
  @Input() form: FormGroup;
  public displayConditionTypes = Object.keys(DisplayConditionTypeGroup).map(type => DisplayConditionTypeValue[type]);

  constructor() {}

  ngOnInit() {}
}
